/**
 * Browser stub for Node's fs module. Used by @captor/openseries-ts
 * which bundles Node-only code (plotSeries, reportHtml) we don't use.
 */
export const writeFileSync = (_path: string, _data: string): void => {};
export const existsSync = (_path: string): boolean => false;
export const readFileSync = (_path: string): Buffer => Buffer.from("");
